import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  is_display_product_register_component = false;
  productUpdate = new EventEmitter<Product>();

  downloadProduct = new EventEmitter<boolean>();

  private _product_data: Product = null;
  constructor() {
  }

  set set_product_data(product) {
    this._product_data = product;
  }

  get get_product_data() {
    return this._product_data;
  }
}

export interface Product {
  id: number;
  name: string;
}
